<figure class="sms">
  @if (copy) {
    <blockquote class="sms__bubble" [attr.data-size]="size" [style.-webkit-line-clamp]="clamp > 0 ? clamp : null" [class.is-unclamped]="clamp <= 0">
      <bk-sms-text [text]="copy" />
    </blockquote>

    <figcaption class="sms__meter">
      <span class="sms__ruler" aria-hidden="true">
        <!-- To scale: each capsule is as many px as its part holds characters -->
        @for (fill of parts.fills; track $index) {
          <span class="sms__part" [style.--per]="parts.perPart">
            <span class="sms__fill" [style.--fill]="fill" [style.--d]="$index"></span>
          </span>
        }
      </span>
      <span class="sms__caption">
        {{ lengthLabel }}<span class="sms__sep">·</span>{{ partsLabel }}
        @if (encodingLabel) {
          <span class="sms__sep">·</span><span class="sms__note">{{ encodingLabel }}</span>
        }
      </span>
    </figcaption>
  } @else {
    <blockquote class="sms__bubble sms__bubble--empty" [attr.data-size]="size">
      {{ emptyText }}
    </blockquote>
  }
</figure>
